export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_06.fb4af8dc.jpg";